module.exports = "\n    <div class=\"form--row\"  ng-class=\"{'have-error':$ctrl.haveError}\">\n      <label class=\"form--control-label\">\n        <span class=\"form--control-label-text\" ng-bind=\"$ctrl.label\"></span>\n        <tooltip field-info=\"$ctrl.label\" field-name=\"$ctrl.fieldName\" have-error=\"$ctrl.haveError\" error-message=\"$ctrl.errorMessage\"></tooltip>\n        <input type=\"text\" class=\"form--control\" ng-model=\"$ctrl.model\" value=\"000-000-000 00\">\n      </label>\n    </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/html/snils.html
// module id = 140
// module chunks = 1